import { BRAND, BTN } from '@/enum/enum';
import { createStore } from 'vuex';
import { LANG,THEME_OPT } from '@/enum/enum';

export default createStore({
    state: {
        isShowModal: false,
        modalType: '-1',
        modalData: null, // 
        modalOutput: null,
        modalBtnType: BTN.CANCEL,
        isBackToCalibration: false,
        isNextToAdvance: false,
        advanceData:{},
        calibrationList: {}, //在device或group頁面被選到要進入color calibration頁的list
        calibrationPostData: {},
        env: '',
        apiReq: null,
        isLoading: false,
        isShowFlashMsg: false,
        flashMsgText: '---',
        wsSite: '',
        wsData: {},
        userInfo: {
            name: '',
            email: '',
            gtmUserId: null,
            isShowPrivacy: true,
            isShowEULA: true,
        },
        routerPath: '',
        goApply: false,
        isNeedAPILoding: true, //是否需要顯示api loading
        apiCount: 0, //計算同時打出的API數量 (影響loading持續與否)
        updateTime: 1000 * 60, // 多久自動更新一次
        refreshTime: '--', //全站更新時間
        wsOffline :false,
        alertNotification: 0,
        alertUpdateTime: 1000 * 10, // 訊息數量多久自動更新一次
        mobileDevice : false,
        isRWDBreakingPoint: false,
        openSideBar : false,
        langIsSelected : LANG.EN,
        theme: THEME_OPT.PROART,
        brand: BRAND.PROART,


    },
    mutations: {
        setBrand(state, val) {
            state.brand = val;
        },
        setTheme(state, val) {
            state.theme = val;
        },
        setRefreshTime(state, val) {
            state.refreshTime = val;
        },
        setAlertNotification(state, val) {
            let num;
            if(val > 999){
                num = '999+'
            }else{
                num = val
            }
            state.alertNotification = num;
        },
        //是否需要API Loading
        setIsNeedLoading(state, val) {
            state.isNeedAPILoding = val;
        },
        setApiCount(state, val) {
            state.apiCount += val;
        },
        /**
         * 是否顯示modal 
         * @param state 
         * @param val   {type: number -  modal是哪個, isShow : boolean, 開或關, data: any 要傳入或傳出的資料}
         */
        setIsShowModal(state, val) {
            // console.log('setIsShowModal');
            const { type, isShow, data } = val;
            state.isShowModal = isShow;
            state.modalType = type;
            state.modalData = data;
            // console.log('state', state);
        },
        /**
         *  關掉modal
         */
        setCloseModal(state) {
            console.log('setCloseModal');
            state.isShowModal = false;
            setTimeout(() => {
                console.log('settmtout');
                state.modalType = '-1';
            }, 400);
            // console.log('setCloseModal state', state);
        },
        setModalBtnType(state, val) {
            state.modalBtnType = val;
        },
        setModalOutput(state, val) {
            state.modalOutput = val;
        },
        setCalibrationList(state, val) {
            state.calibrationList = val;
            // console.log(state.calibrationList,'state.calibrationList')
        },
        setCalibrationPostData(state, val) {
            state.calibrationPostData = val;
        },
        backToCalibration(state, val) {
            state.isBackToCalibration = val;
        },
        nextToAdvance(state, val) {
            state.isNextToAdvance = val;
        },
        setAdvanceData(state, val) {
            state.advanceData = val;
        },
        setEnv(state, val) {
            state.env = val;
        },
        setAPIRequet(state, val) {
            // console.log('setAPIRequet', val);
            state.apiReq = val;
            // console.log('state.apiReq', state.apiReq);
        },
        setIsLoading(state, val) {
            state.isLoading = val;
        },
        setFlashMsg(state, val) {  //出現flash msg
            const { data, isShow } = val;
            state.isShowFlashMsg = isShow;
            state.flashMsgText = data;
        },
        setFlashMsgClose(state) {  // hide flash msg
            state.isShowFlashMsg = false;
        },
        setWsSite(state, val) {
            state.wsSite = val;
        },
        setWsData(state, val) {
            state.wsData = val;
        },

        setWsOffline(state, val) {
            state.wsOffline = val;
        },
        setUserInfo(state, val) {
            const { name, email,gtmUserId, isShowEULA, isShowPrivacy } = val;
            state.userInfo.name = name;
            state.userInfo.email = email;
            state.userInfo.gtmUserId = gtmUserId;
            state.userInfo.isShowPrivacy = isShowPrivacy;
            state.userInfo.isShowEULA = isShowEULA;
        },
        setEULA(state, val) {
            state.userInfo.isShowEULA = val;
        },
        setPrivacy(state, val) {
            state.userInfo.isShowPrivacy = val;
        },
        setRouterPath(state, val) {
            state.routerPath = val;
        },
        setGoApply(state, val) {
            state.goApply = val;
        },
        setMobileDevice(state, val) {
            state.mobileDevice = val;
        },
        setIsRWDBreakingPoint(state, val) {
            state.isRWDBreakingPoint = val;
        },
        setOpenSideBar(state, val) {
            state.openSideBar = val;
        },
        setLangIsSelected(state, val) {
            state.langIsSelected = val;
        },
    },
    actions: {

    },
    getters: {
        getEnv(state) {
            return state.env;
        },
        getAlertNotification(state) {
            return state.alertNotification;
        },
        getIsLoading(state) {
            return state.isLoading;
        },
        getUserEmail(state) {
            return state.userInfo.email;
        },
        getIsShowPrivacy(state) {
            return state.userInfo.isShowPrivacy;
        },
        getIsShowEULA(state) {
            return state.userInfo.isShowEULA;
        },
        getLangIsSelected(state) {
            return state.langIsSelected
        },


    },
    modules: {

    }
})